import OnboardingConfirmMoneyMap from '../../../onboarding/components/OnboardingConfirmMoneyMap';

export default function OnboardingConfirmMoneyMapScreen() {
    return <OnboardingConfirmMoneyMap />;
}
